export default "__VITE_PUBLIC_ASSET__7378d3c7__"